import _objectSpread from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\Users\\Himanshu\\OneDrive\\Desktop\\Portfolio Website\\portfolio-website\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import * as THREE from 'three';
import { useThree } from '@react-three/fiber';

// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function useFBO( /** Width in pixels, or settings (will render fullscreen by default) */
width, /** Height in pixels */
height, /**Settings */
settings) {
  var size = useThree(function (state) {
    return state.size;
  });
  var viewport = useThree(function (state) {
    return state.viewport;
  });
  var _width = typeof width === 'number' ? width : size.width * viewport.dpr;
  var _height = typeof height === 'number' ? height : size.height * viewport.dpr;
  var _settings = (typeof width === 'number' ? settings : width) || {};
  var _settings$samples = _settings.samples,
    samples = _settings$samples === void 0 ? 0 : _settings$samples,
    depth = _settings.depth,
    targetSettings = _objectWithoutProperties(_settings, ["samples", "depth"]);
  var target = React.useMemo(function () {
    var target = new THREE.WebGLRenderTarget(_width, _height, _objectSpread({
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      type: THREE.HalfFloatType
    }, targetSettings));
    if (depth) {
      target.depthTexture = new THREE.DepthTexture(_width, _height, THREE.FloatType);
    }
    target.samples = samples;
    return target;
  }, []);
  React.useLayoutEffect(function () {
    target.setSize(_width, _height);
    if (samples) target.samples = samples;
  }, [samples, target, _width, _height]);
  React.useEffect(function () {
    return function () {
      return target.dispose();
    };
  }, []);
  return target;
}
export { useFBO };